import { render, staticRenderFns } from "./Export.vue?vue&type=template&id=23245224&scoped=true"
import script from "./Export.vue?vue&type=script&lang=js"
export * from "./Export.vue?vue&type=script&lang=js"
import style0 from "./Export.vue?vue&type=style&index=0&id=23245224&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23245224",
  null
  
)

export default component.exports